export default (tourCriteria) => {
    const params = {};
    const element = tourCriteria.get('departureCity');
    if (element) {
        params.fromCity = element.get('id');
    }

    return params;
};